"use client";

import React, { useEffect, useState } from "react";
import {
  COLORADO_SECTION_ID,
  CONNECTICUT_SECTION_ID,
  DISTRICT_OF_COLUMBIA_SECTION_ID,
  FLORIDA_SECTION_ID,
  ILLINOIS_SECTION_ID,
  IOWA_SECTION_ID,
  MARYLAND_SECTION_ID,
  MASSACHUSETTS_SECTION_ID,
  MINNESOTA_SECTION_ID,
  OKLAHOMA_SECTION_ID,
  RHODE_ISLAND_SECTION_ID,
  SOUTH_DAKOTA_SECTION_ID,
  WASHINGTON_SECTION_ID,
  KANSAS_SECTION_ID,
} from "../../constants/ids";
import DesktopAside from "./desktopAside";
import MobileAside from "./mobileAside";

export const sections = [
  COLORADO_SECTION_ID,
  CONNECTICUT_SECTION_ID,
  DISTRICT_OF_COLUMBIA_SECTION_ID,
  FLORIDA_SECTION_ID,
  ILLINOIS_SECTION_ID,
  IOWA_SECTION_ID,
  KANSAS_SECTION_ID,
  MARYLAND_SECTION_ID,
  MASSACHUSETTS_SECTION_ID,
  MINNESOTA_SECTION_ID,
  OKLAHOMA_SECTION_ID,
  RHODE_ISLAND_SECTION_ID,
  SOUTH_DAKOTA_SECTION_ID,
  WASHINGTON_SECTION_ID,
];

const DisclosureAside = () => {
  const [hash, setHash] = useState(`#${COLORADO_SECTION_ID}`);

  useEffect(() => {
    setHash(window.location.hash || `#${COLORADO_SECTION_ID}`);
  }, []);

  const handleSetHash = (arg: string) => {
    setHash(`#${arg}`);
  };

  return (
    <aside className="ss:flex-1 ss:md:max-w-50 ss:lg:max-w-75">
      <MobileAside handleSetHash={handleSetHash} hash={hash} />
      <DesktopAside handleSetHash={handleSetHash} hash={hash} />
    </aside>
  );
};

export default DisclosureAside;
